import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_SupervisionSign = ({
   itemsRef,
   showErrorFor,
}) => {

   return (
      <form id='ACTS_SupervisionSign' className='file-pdf-document'>
         <div className='file-template'>

            <h3>
               MST WEEKLY SUPERVISION SIGN-IN
            </h3>
            <h4>
               (Location: 2706 Saint Jude street, Greensboro, NC 27505)
            </h4>
            <table>
               <tr>
                  <td className='w-250'>
                     <span className='eleHeader'>Date:</span>                     
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Time:</span>                    
                  </td>
                  <td className='w-250'>
                     <span className='eleHeader'>Purpose:</span>                     
                  </td>
               </tr>
               <tr>
                  <td className='w-250'>
                  <input type='date' id="txtDate" name="txtDate" className='add-only' />
                  </td>
                  <td className='w-250'>
                  1:30pm-3:30pm (Mondays)
                  </td>
                  <td className='w-250'>
                  To provide Weekly Supervision
                  </td>
               </tr>              
            </table>
            <h4>
               Sign-In Log
            </h4>
            <table>
               <tr>
                  <td className='w-750'>
                  1. <input type="text" id="txtSignIn1" name="txtSignIn1" placeholder="(MST Supervisor)" className='add-only w-730 custom-add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                  2.  <input type="text" id="txtSignIn2" name="txtSignIn2" placeholder="(MST Supervisor)" className='add-only w-730 custom-add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                  3.   <input type="text" id="txtSignIn3" name="txtSignIn3" placeholder="(MST Supervisor)" className='add-only w-730 custom-add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-750'>
                  4. <input type="text" id="txtSignIn4" name="txtSignIn4" placeholder="(MST Supervisor)" className='add-only w-730 custom-add-only' />
                  </td>
               </tr>
               <tr>                  
                  <td className='w-750'>
                  5.  <input type="text" id="txtSignIn5" name="txtSignIn5" placeholder="(MST Supervisor)" className='add-only w-730 custom-add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='w-375'>
                  6. <input type="text" id="txtPrintName" name="txtPrintName" placeholder="(Print Name)" className='add-only w-355 custom-add-only' />
                  </td>
                  <td className='w-375'>
                     <input type="text" id="txtTitle" name="txtTitle" placeholder="(Title)" className='add-only w-355 custom-add-only' />
                  </td>
               </tr>
               <tr>
                  <td className='w-375'>
                  7. <input type="text" id="txtPrintName1" name="txtPrintName1" placeholder="(Print Name)" className='add-only w-355 custom-add-only' />
                  </td>
                  <td className='w-375'>
                     <input type="text" id="txtTitle1" name="txtTitle1" placeholder="(Title)" className='add-only w-355 custom-add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>                  
                  <td className='w-750'>
                  1. <input type="text" id="txtSignIn6" name="txtSignIn6" className='add-only w-730 custom-add-only' />
                  </td>
               </tr>
               <tr>
                 
                  <td className='w-750'>
                  2. <input type="text" id="txtSignIn9" name="txtSignIn9" className='add-only w-730 custom-add-only' />
                  </td>
               </tr>
               <tr>
                  
                  <td className='w-750'>
                  3. <input type="text" id="txtSignIn10" name="txtSignIn10" className='add-only w-730 custom-add-only' />
                  </td>
               </tr>
               <tr>
                 
                  <td className='w-750'>
                  4. <input type="text" id="txtSignIn11" name="txtSignIn11" className='add-only w-730 custom-add-only' />
                  </td>
               </tr>
               <tr>
                 
                  <td className='w-750'>
                  5. <input type="text" id="txtSignIn12" name="txtSignIn12" className='add-only w-730 custom-add-only' />
                  </td>
               </tr>
            </table>
            <table>
               <tr>
                  <td className='signature w-730'> </td>                 
               </tr>
               <tr>
               <td className='small w-20'> 6.</td>
                  <td className='small w-730'> (Signature)</td>                  
               </tr>
               <tr>
                  <td className='signature w-730'> </td>                 
               </tr>
               <tr>
               <td className='small w-20'> 7.</td>
                  <td className='small w-730'> (Signature)</td>                 
               </tr>
               <tr>
                  <td className='signature w-730'> </td>                  
               </tr>
               <tr>
               <td className='small w-20'> 8.</td>
                  <td className='small w-730'> (Signature)</td>                  
               </tr>
            </table>


         </div>
      </form>

   )
}  
